<div class="animation-trigger-map">
  <div *ngFor="let row of rows; let i = index" class="trigger-row p-formgroup-inline p-my-2">
    <p-dropdown
      [options]="getAvailableTriggers(row)"
      [(ngModel)]="row.trigger"
      optionLabel="name"
      placeholder="Select trigger"
      [showClear]="true"
      (onChange)="onTriggerChange(row, $event.value)"
      [style]="{'min-width': '180px'}">
    </p-dropdown>

    <p-dropdown
      [options]="getOptionsForRow(row)"
      [(ngModel)]="row.selectedOption"
      placeholder="Select option"
      [showClear]="true"
      [disabled]="!row.trigger"
      (onChange)="onOptionChange(row, $event.value)"
      [style]="{'min-width': '220px'}"
      class="p-mx-2">
    </p-dropdown>

    <button pButton type="button" icon="pi pi-times"
      class="p-button-rounded p-button-text p-button-danger"
      (click)="removeRow(i)">
    </button>
  </div>

  <button pButton type="button" icon="pi pi-plus" label="Add trigger"
    class="p-button-text p-button-sm p-mt-1"
    (click)="addRow()">
  </button>
</div>
